<template>
	<form-sidebar>
		<header>
			<h2>
				¿Está seguro que desea eliminar la defininición Ats"{{ name }}"?
			</h2>
		</header>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				@cancel-button-clicked="$emit('close-modal')"
				@accept-button-clicked="submitForm"
			>
			</modal-sidebar-button>
		</section>
	</form-sidebar>
</template>

<script>

function data() {
	return {
		modules: [],
	};
}

async function submitForm() {
	try {
		await this.$http.delete(`transactional-definitions/${this.id}`);
		this.$emit('close-modal', true);
		this.showNotification('Definición Ats eliminada correctamente');
	} catch (error) {
		this.showGenericError();
	}
}

export default {
	name: 'account-definitions-remove',
	data,
	methods: {
		submitForm,
	},
	props: {
		id: {
			type: Number,
			default: null,
		},
		name: {
			type: String,
			required: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/definitions-ats/definitions-ats-remove.vue